// extracted by mini-css-extract-plugin
export default {"root":"_1yNlY","image":"f4cZV","large":"Z4vtv","medium":"_3q52H","small":"_3kUES"};